import React, { useEffect } from 'react';
import { trans } from '../../../_providers/Translation'

function Todo(props) {

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('tables.activity')}</th>
                    <th>{trans('tables.date')}</th>
                    <th>{trans('tables.employee')}</th>

                    <th>{trans('tables.title')}</th>
                    <th>{trans('tables.text')}</th>
                    <th>{trans('tables.description')}</th>
                    <th>{trans('tables.date')}</th>
                    <th>{trans('tables.deadline')}</th>
                    <th>{trans('tables.due_date')}</th>
                    <th>{trans('tables.author_id')}</th>
                 
                    <th>{trans('tables.customer_id')}</th>
                    <th>{trans('tables.reservation_id')}</th>
                    <th>{trans('tables.priority_id')}</th>
                    <th>{trans('tables.read_at')}</th>
                    <th>{trans('tables.paused_at')}</th>
                    <th>{trans('tables.completed_at')}</th>
                    <th>{trans('tables.file')}</th>
                    <th>{trans('tables.filename')}</th>
                    <th>{trans('tables.repeat')}</th>
                    <th>{trans('tables.repeat_after')}</th>
                    <th>{trans('tables.repeat_period')}</th>
                    <th>{trans('tables.repeat_days')}</th>
                    <th>{trans('tables.flagged')}</th>
                    <th>{trans('tables.shared')}</th>
                    <th>{trans('tables.shared_by_tenant_id')}</th>
                    <th>{trans('tables.shared_to_tenant_id')}</th>
                    <th>{trans('tables.origin_todo_id')}</th>
                    <th>{trans('tables.assigned_to_emp_id')}</th>
                    <th>{trans('tables.assigned_by_emp_id')}</th>
                    <th>{trans('tables.postponed_until')}</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map((h, i) => (
                    <tr key={i} className={[h.actual ? 'actual' : h.selected ? 'selected' : '']}>
                            <td>{h.event}</td>
                            <td>{h.date}</td>
                            <td>{h.causer ? `${h.causer.name} ${h.causer.lastname}` : '-'}</td>
                            <td>{h.subject?.title ?? '-'}</td>
                            <td>{h.subject?.text ?? '-'}</td>
                            <td>{h.subject?.description ?? '-'}</td>
                            <td>{h.subject?.date ?? '-'}</td>
                            <td>{h.subject?.deadline ?? '-'}</td>
                            <td>{h.subject?.due_date ?? '-'}</td>
                            <td>{h.subject?.author_id ?? '-'}</td>
                    
                            <td>{h.subject?.customer_id ?? '-'}</td>
                            <td>{h.subject?.reservation_id ?? '-'}</td>
                            <td>{h.subject?.priority?.name ?? '-'}</td>
                            <td>{h.subject?.read_at ?? '-'}</td>
                            <td>{h.subject?.paused_at ?? '-'}</td>
                            <td>{h.subject?.completed_at ?? '-'}</td>
                            <td>{h.subject?.file ?? '-'}</td>
                            <td>{h.subject?.filename ?? '-'}</td>
                            <td>{h.subject?.repeat ?? '-'}</td>
                            <td>{h.subject?.repeat_after ?? '-'}</td>
                            <td>{h.subject?.repeat_period ?? '-'}</td>
                            <td>{h.subject?.repeat_days ?? '-'}</td>
                            <td>{h.subject?.flagged ?? '-'}</td>
                            <td>{h.subject?.shared ?? '-'}</td>
                            <td>{h.subject?.shared_by_tenant_id ?? '-'}</td>
                            <td>{h.subject?.shared_to_tenant_id ?? '-'}</td>
                            <td>{h.subject?.origin_todo_id ?? '-'}</td>
                            <td>{h.subject?.assigned_to_emp_id ?? '-'}</td>
                            <td>{h.subject?.assigned_by_emp_id ?? '-'}</td>
                            <td>{h.subject?.postponed_until ?? '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default Todo;